import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useFetchAsset from '../../../pages/NRReport/useFetchAsset';
import useNRQuery from '../../../graphql/useNRQuery';
import { GET_GROUP_ASSETS_NAMES } from '../../../graphql/queries/asset';
import { CONSTANTS } from '../../../constants/constants';
import useFetchAssetGroups from '../../AssetGroup/useFetchAssetGroups';
import { compareAssetIdAlone } from '../../../utils/utils';

export default function GroupAssetsBreadcrumbElement({ params }) {
  const { groupId, componentId } = params;
  const theme = useTheme();
  const navigate = useNavigate();
  useFetchAssetGroups();
  useFetchAsset();

  const [selectedAsset, setSelectedAsset] = useState(null);

  const [assets, loading] = useNRQuery({
    query: GET_GROUP_ASSETS_NAMES,
    options: {
      context: { version: 'v3' },
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          cursor: { first: 10000 },
          groupId,
          sort: {
            field: CONSTANTS.TABLE.ASSETS.FILTERS.FIELDS.name,
            order: CONSTANTS.TABLE.ASSETS.FILTERS.ORDER.ASC
          }
        }
      }
    },
    qlObjKey: 'assetGroupMembers',
    defaultValue: [],
    transformData: data => data?.edges?.map(item => item.node)
  });

  useEffect(() => {
    const assetFound = assets.find(a => compareAssetIdAlone(a.id, componentId));
    if (assetFound) setSelectedAsset(assetFound);
  }, [assets, componentId]);

  const handleChange = value => {
    const assetFound = assets.find(asset => compareAssetIdAlone(asset.id, value));
    if (!!assetFound) {
      setSelectedAsset(assetFound);
    } else {
      navigate(`/assets/${value.replaceAll('|', '%7C')}`);
    }
  };

  useEffect(() => {
    if (!selectedAsset || compareAssetIdAlone(selectedAsset?.id, componentId)) return;
    navigate(`/groups/${groupId}/${selectedAsset.id.replaceAll('|', '%7C')}`);
  }, [selectedAsset]);

  return (
    <Box sx={{ marginLeft: 1 }}>
      {selectedAsset && assets.length > 0 && (
        <Select
          id="asset-selector"
          value={selectedAsset.id}
          onChange={e => handleChange(e.target.value)}
          size="small"
          variant="standard"
          autoWidth
          sx={{
            ...theme.typography.body2,
            color: theme.palette.text.icon,
            '&.MuiInput-underline': {
              '&:before': { borderBottom: 'none' },
              '&:after': { borderBottom: 'none' },
              '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
              '& > svg': { top: theme.spacing(-0.25) }
            }
          }}
          MenuProps={{
            MenuListProps: {
              sx: { width: '300px' }
            }
          }}
        >
          {assets.map(({ id, name, status }) => (
            <MenuItem disabled={status !== CONSTANTS.TABLE.ASSETS.STATUS.COMPLETED} value={id} key={id}>
              <Tooltip title={name.length > 35 ? name : ''}>
                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</Box>
              </Tooltip>
            </MenuItem>
          ))}
        </Select>
      )}
      {loading && <Typography variant={'body2'}>Loading...</Typography>}
    </Box>
  );
}
